import { render, staticRenderFns } from "./Issued.vue?vue&type=template&id=63386453&scoped=true"
import script from "./Issued.vue?vue&type=script&lang=js"
export * from "./Issued.vue?vue&type=script&lang=js"
import style0 from "./Issued.vue?vue&type=style&index=0&id=63386453&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63386453",
  null
  
)

export default component.exports